import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Camera, Heart, ArrowRight, Sparkles } from "lucide-react";
import { SITE_INFO, HERO_TEXT } from "../mock";

export default function About() {
  return (
    <div className="bg-black text-white min-h-screen pt-32 pb-24">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16 fade-in">
          <p className="text-gold text-sm tracking-[0.3em] uppercase mb-4">Rencontre</p>
          <h1 className="text-5xl md:text-6xl mb-6 section-title"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            À propos
          </h1>
          <div className="gold-divider" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16">
          <div className="aspect-[3/4] overflow-hidden">
            <img
              src="/ludovic.jpg"
              alt="Ludovic Garcia"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="space-y-5">
            <p className="text-gold text-sm tracking-[0.2em] uppercase">
              Ludovic Garcia
            </p>
            <h2 className="text-4xl md:text-5xl italic"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
              {HERO_TEXT.intro}
            </h2>
            <div className="gold-divider !mx-0 !w-20" />
            <p className="text-gray-300 leading-relaxed">{HERO_TEXT.description}</p>
            <p className="text-white/90 italic leading-relaxed">{HERO_TEXT.specialties}</p>
            <p className="text-white/90 italic leading-relaxed">{HERO_TEXT.events}</p>
            <p className="text-gray-400 leading-relaxed">{HERO_TEXT.closing}</p>

            <div className="flex items-center gap-3 pt-4 text-gold">
              <MapPin size={20} strokeWidth={1.5} />
              <span className="text-sm tracking-wider">{SITE_INFO.location} — Toute la France</span>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-16">
          {[
            { Icon: Camera, title: "Matériel pro", text: "Équipement haut de gamme pour une qualité irréprochable." },
            { Icon: Heart, title: "Approche humaine", text: "Écoute, bienveillance et direction pour vous mettre à l'aise." },
            { Icon: Sparkles, title: "Retouche sur place", text: "Vos photos retouchées et signées le jour même." }
          ].map((v) => (
            <div key={v.title} className="border border-white/10 p-6 bg-zinc-950/40 text-center">
              <v.Icon size={32} className="text-gold mx-auto mb-4" strokeWidth={1} />
              <h3 className="text-xl mb-2"
                  style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}>
                {v.title}
              </h3>
              <p className="text-gray-400 text-sm">{v.text}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <Link to="/contact" className="btn-gold">
            Prendre contact
            <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  );
}
